// extracted by mini-css-extract-plugin
module.exports = {"icon":"Modal_icon__1g9yc","actions":"Modal_actions__30-_H","root":"Modal_root__2l3uD","content":"Modal_content__3f5Yj","goToDraftsBtn":"Modal_goToDraftsBtn___CWMt"};